module.exports = __webpack_public_path__ + "static/media/Dislike.04bcfc06.svg";